import { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { radius, spacing } from 'common/theme';

const SCROLL_HIDE_THRESHOLD = 8;

export const usePopupLayout = () => {
    const deviceState = useSelector((store) => store.state.deviceState);
    const isMobile = deviceState === 'mobile';
    const isTablet = deviceState === 'tablet';
    const [isScrolled, setIsScrolled] = useState(false);

    useLayoutEffect(() => {
        if (!isMobile) {
            return undefined;
        }

        const onScroll = () => {
            setIsScrolled(window.scrollY > SCROLL_HIDE_THRESHOLD);
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [isMobile]);

    return {
        badgeCircleSize: isMobile ? 40 : isTablet ? 38 : 40,
        containerSx: isMobile ? {
            position: 'relative',
            width: '100%',
            maxWidth: 'none',
            overflow: 'hidden',
            transition: 'max-height 0.25s ease, opacity 0.2s ease',
            ...(isScrolled ? {
                maxHeight: 0,
                opacity: 0,
                pointerEvents: 'none',
            } : {
                maxHeight: '400px',
                opacity: 1,
            }),
        } : {
            position: 'absolute',
            top: `calc(100% + ${spacing.xs}px)`,
            left: '50%',
            right: 'auto',
            transform: 'translateX(-50%)',
            width: 'auto',
            minWidth: 350,
            maxWidth: 500,
        },
        panelSx: {
            borderRadius: {
                xs: 0,
                sm: `${radius.md}px`,
                md: `${radius.lg}px`,
            },
            pt: { xs: `${spacing.md}px`, md: `${spacing.lg}px` },
            pb: { xs: `${spacing.md}px`, md: `${spacing.lg}px` },
            px: { xs: `${spacing.md}px`, md: `${spacing.lg}px` },
        },
        bodySx: {
            gap: { xs: `${spacing.md}px`, md: `${spacing.xl}px` },
            pr: { xs: `${spacing.lg}px`, md: `${spacing.xxl}px` },
            pl: { xs: `${spacing.sm}px`, md: `${spacing.xl}px` },
            alignItems: 'center',
            minHeight: { xs: 64, md: 84 },
        },
        closeIconSize: { xs: 11, sm: 11, md: 12 },
        chevronWidth: { xs: 8, sm: 7, md: 8 },
    };
};
